import platformFaviconUrl from '../assets/favicon.png';

const FAVICON_LINK_ID = 'app-favicon';

/** Routes where published / embedded customer docs may set their own favicon. */
export function isCustomerBrandedRoute(pathname) {
  const p = pathname || '';
  if (p.startsWith('/docs/')) return true;
  if (p.startsWith('/embed/')) return true;
  return false;
}

export function getPlatformFaviconUrl() {
  return platformFaviconUrl;
}

/**
 * Set the document favicon. Use source "space" only on customer doc/embed surfaces.
 */
export function applyFavicon(href, source = 'platform') {
  if (!href) return;
  let link = document.getElementById(FAVICON_LINK_ID);
  if (!link) {
    document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon']").forEach((el) => {
      if (el.id !== FAVICON_LINK_ID) el.remove();
    });
    link = document.createElement('link');
    link.id = FAVICON_LINK_ID;
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.rel = 'icon';
  link.type = href.toLowerCase().endsWith('.ico') ? 'image/x-icon' : 'image/png';
  link.href = href;
  link.dataset.faviconSource = source;
}

export function applyPlatformFavicon() {
  applyFavicon(platformFaviconUrl, 'platform');
}

export function applySpaceFavicon(resolvedUrl) {
  applyFavicon(resolvedUrl, 'space');
}
